export const faIcons = [
  // 👤 Présentation / Profil
  { label: "Utilisateur", value: "fas fa-user" },
  { label: "Profil professionnel", value: "fas fa-id-badge" },
  { label: "À propos", value: "fas fa-address-card" },

  // 📂 Expérience & Réalisations
  { label: "Portfolio", value: "fas fa-briefcase" },
  { label: "Projets", value: "fas fa-folder-open" },
  { label: "Code", value: "fas fa-code" },
  { label: "Design", value: "fas fa-paint-brush" },
  { label: "Trophée", value: "fas fa-trophy" },
  { label: "Étoile", value: "fas fa-star" },

  // 📅 Disponibilité & Organisation
  { label: "Calendrier", value: "fas fa-calendar" },
  { label: "Horloge", value: "fas fa-clock" },
  { label: "Disponible", value: "fas fa-check-circle" },

  // 📞 Contact
  { label: "Téléphone", value: "fas fa-phone" },
  { label: "E-mail", value: "fas fa-envelope" },
  { label: "LinkedIn", value: "fab fa-linkedin" },
  { label: "GitHub", value: "fab fa-github" },
  { label: "Globe (Site web)", value: "fas fa-globe" },

  // 💡 Divers utiles
  { label: "Cœur", value: "fas fa-heart" },
  { label: "Ampoule (idées)", value: "fas fa-lightbulb" },
  { label: "Maison", value: "fas fa-home" },
];
